import { baseFetch, baseFetchWithoutResponse } from "./baseRequest";

// Get loan details
export const getLoanDetails = (loanDetails) => {
  return baseFetch("/Payments/GetLoanInformationV2", "POST", JSON.stringify(loanDetails));
};

// Validate loan payment
export const validateLoanPayment = (paymentDetails) => {
  return baseFetch("/Payments/VerifyPayment", "POST", JSON.stringify(paymentDetails));
};

// Submit debit card loan payment
export const submitLoanPayment = () => {
  return baseFetch("/Payments/SubmitPayment", "POST");
};

// Submit ACH loan payment
export const submitAchLoanPayment = (paymentDetails) => {
  return baseFetch("/Payments/SubmitAchPayment", "POST", JSON.stringify(paymentDetails));
};

export const calculateAchPostDate = (paymentDetails) => {
  return baseFetch("/Payments/CalculateAchPostDate", "POST", JSON.stringify(paymentDetails));
};

//Check if this payment qualifies for payoff
export const checkPayoff = (checkPayoffObject) => {
  return baseFetch(`/Payments/PayoffCheck`, "POST", JSON.stringify(checkPayoffObject));
};

// Get token
export const getTokenRequest = () => {
  return baseFetch("/RequestToken", {});
};

// Unauthenticate token
export const getUnauthenticateToken = () => {
  return baseFetch("/UnauthenticateToken", {});
};

// Get Ach Institution
export const getInstitutionFromRoutingNumber = (routingNumber) => {
  return baseFetch(`/RoutingNumberToInstitution/${routingNumber}`, {});
};

export const verifyAppraisalCharge = (paymentDetails) => {
  return baseFetch("/AppraisalCharge/VerifyPayment", "POST", JSON.stringify(paymentDetails));
};

export const submitAppraisalCharge = (paymentDetails) => {
  return baseFetch("/AppraisalCharge/SubmitPayment", "POST");
};

export const validateSSN = (details) => {
  return baseFetch(
    "/AppraisalCharge/Validate",
    "POST",
    JSON.stringify({
      socialSecurity: details.ssn,
      externalAuthGuid: details.guid,
      token: details.token,
    }),
  );
};

// For authenticated payments flow

export const beginAuthSession = (guid) => {
  return baseFetchWithoutResponse(
    "/AuthenticatedLoanPayments/BeginSession",
    "POST",
    JSON.stringify({ ExternalAuthGuid: guid }),
  );
};

export const authGetLoans = () => {
  return baseFetch("/AuthenticatedLoanPayments/GetLoans");
};

export const authGetInternalAccounts = () => {
  return baseFetch("/AuthenticatedLoanPayments/GetInternalTransferAccounts");
};

export const authGetAdditionalLoanDetails = () => {
  return baseFetch("/AuthenticatedLoanPayments/GetSelectedLoanInformation");
};

export const authSaveInternal = (paymentDetails) => {
  return baseFetch(
    "/AuthenticatedLoanPayments/SaveTransferInfo",
    "POST",
    JSON.stringify(paymentDetails),
  );
};

export const authSubmitInternalTransfer = () => {
  return baseFetch("/AuthenticatedLoanPayments/SubmitTransfer", "POST");
};

export const authSubmitInternalTransferToCreditCard = () => {
  return baseFetch("/AuthenticatedLoanPayments/SubmitTransferToCreditCardAccount", "POST");
};

export const createAuthPaymentRecord = (loanNumber) => {
  return baseFetchWithoutResponse(
    "/AuthenticatedLoanPayments/CreatePaymentRecord",
    "POST",
    JSON.stringify({ LoanNumberHash: loanNumber }),
  );
};

export const authSaveDebit = (paymentDetails) => {
  return baseFetch(
    "/AuthenticatedLoanPayments/SaveDebitInfo",
    "POST",
    JSON.stringify(paymentDetails),
  );
};

export const authVerifySkipPayment = (paymentDetails) => {
  return baseFetch("/SkipPayment/VerifyPayment", "POST", JSON.stringify(paymentDetails));
};

export const authSubmitSkipDebitPayment = (paymentDetails) => {
  return baseFetch("/SkipPayment/SubmitPayment", "POST", JSON.stringify(paymentDetails));
};

export const authPostSkip = (skipDetails) => {
  return baseFetch("/SkipPayment/PostSkipPayment", "POST", JSON.stringify(skipDetails));
};

export const authGetSkipLoanInfo = (loanNumber) => {
  return baseFetch(
    "/SkipPayment/GetSkipAPayLoanInfo",
    "POST",
    JSON.stringify({ LoanNumber: loanNumber }),
  );
};

export const authGetSkipEligibility = (loanNumber) => {
  return baseFetch(
    "/SkipPayment/IsEligibleForSkipPayment",
    "POST",
    JSON.stringify({ LoanNumber: loanNumber }),
  );
};

export const authSubmitDebitPayment = () => {
  return baseFetch("/AuthenticatedLoanPayments/SubmitPayment", "POST");
};

export const authSubmitAchPayment = (paymentDetails) => {
  return baseFetch(
    "/AuthenticatedLoanPayments/SubmitAchPayment",
    "POST",
    JSON.stringify(paymentDetails),
  );
};

export const authCancelRecurring = (cancelDetails) => {
  return baseFetch(
    "/AuthenticatedLoanPayments/CancelRecurringPaymentAgreement",
    "POST",
    JSON.stringify(cancelDetails),
  );
};

export const calculateAchPostDateV2 = (paymentDetails) => {
  return baseFetch("/Payments/CalculateAchPostDateV2", "POST", JSON.stringify(paymentDetails));
};

export const authLogUserClickedAutopayOnCreditCard = (accountHash) => {
  baseFetchWithoutResponse(
    "/AuthenticatedLoanPayments/LogCreditCardAutoPayAttempt",
    "POST",
    JSON.stringify({ LoanNumberHash: accountHash }),
  );
};

export const getCardType = (cardNumber) => {
  return baseFetch(
    `/AuthenticatedLoanPayments/GetCardType`,
    "POST",
    JSON.stringify({ AccountNumber: cardNumber.replaceAll(" ", "") }),
  );
};

export const getScheduledPayments = () => {
  return baseFetch("/AuthenticatedLoanPayments/GetScheduledPayments");
};

export const cancelFutureDatedPayment = (paymentId) => {
  return baseFetch(
    "/AuthenticatedLoanPayments/CancelScheduledPayment",
    "POST",
    JSON.stringify({ ScheduledPaymentId: paymentId }),
  );
};

export const getAuthRefinanceRedirect = (accountHash) => {
  return baseFetch(
    `/GetLoanAppsRedirect`,
    "POST",
    JSON.stringify({ AccountNumberHash: accountHash, LoanProductId: 4 }),
  );
};

// Requests for travel exemptions and MFA
export const getCreditCardTravelExemptionEligibility = (cardNumber) => {
  return baseFetch(
    "/TravelExemption/IsCreditCardEligible",
    "POST",
    JSON.stringify({ AccountNumber: cardNumber }),
  );
};

export const getDebitCardTravelExemptionEligibility = (agreeNbr) => {
  return baseFetch(
    "/TravelExemption/IsDebitCardEligible",
    "POST",
    JSON.stringify({ AgreeNbr: agreeNbr }),
  );
};

export const getMfaOptions = () => {
  return baseFetch("/TravelExemption/InitializeMfa", "GET");
};

export const sendMfaCode = (method, id) => {
  return baseFetch(
    "/TravelExemption/SendPasscodeV2",
    "POST",
    JSON.stringify({ Method: method, identifier: id }),
  );
};

export const confirmMfaCode = (confirmationCode) => {
  return baseFetch(
    "/TravelExemption/VerifyPasscode",
    "POST",
    JSON.stringify({ Code: confirmationCode }),
  );
};

export const getExemptionCountries = () => {
  return baseFetch("/TravelExemption/GetCountries", "GET");
};

export const getCardOwners = () => {
  return baseFetch("/TravelExemption/GetCardholders", "GET");
};

export const getExistingTravels = () => {
  return baseFetch("/TravelExemption/GetExistingTravelExemptions", "GET");
};

export const cancelExistingTravel = (cardId, exemptionNumber) => {
  return baseFetchWithoutResponse(
    "/TravelExemption/ExpireTravelExemption",
    "POST",
    JSON.stringify({
      CardId: cardId,
      ExemptionNumber: exemptionNumber,
    }),
  );
};

// card controls
export const cardControlsGetCardListRequest = () => {
  return baseFetch("/CardControls/GetCardList");
};

export const cardControlsSessionRequest = (guid) => {
  return baseFetchWithoutResponse(
    "/CardControls/BeginSession",
    "POST",
    JSON.stringify({ ExternalAuthGuid: guid }),
  );
};

export const getCardStatusEligibilityRequest = () => {
  return baseFetch("/CardControls/GetEligibility");
};

export const saveCardStatusRequest = (details) => {
  return baseFetch("/CardControls/SubmitCardStatusApp", "POST", JSON.stringify(details.status));
};

export const savePinUpdateRequest = (agreeNbr, pin) => {
  return baseFetch(
    "/CardControls/SubmitPinUpdate",
    "POST",
    JSON.stringify({ AgreeNbr: agreeNbr, PIN: pin }),
  );
};

export const validatePinRequest = (agreeNbr, pin) => {
  return baseFetch(
    "/CardControls/ValidatePIN",
    "POST",
    JSON.stringify({ AgreeNbr: agreeNbr, PIN: pin }),
  );
};

export const cardControlsGetMailingAddressRequest = () => {
  return baseFetch("/CardControls/GetAddress");
};

export const cardControlsGetBranchesRequest = (zipCode) => {
  return baseFetch("/distance/" + zipCode);
};

export const submitCardReplacementRequest = (agreeNbr, cardType) => {
  return baseFetch(
    "/CardControls/SubmitReplaceDebitCardApplication",
    "POST",
    JSON.stringify({ AgreeNumber: agreeNbr, CardType: cardType }),
  );
};

// end card controls

export const submitTravelExemption = (exemptionDto) => {
  //reason, countries, startDate, endDate, selectedBorrowers) => {
  let endpoint = "/TravelExemption/SubmitApplication";
  if (exemptionDto.exemptionNumber) {
    endpoint = "/TravelExemption/EditApplication";
  }

  return baseFetch(
    endpoint,
    "POST",
    JSON.stringify({
      Reason: exemptionDto.reason,
      TravelExemptionCountries: exemptionDto.countriesArray,
      StartDate: exemptionDto.startDate,
      EndDate: exemptionDto.endDate,
      SelectedCardIds: exemptionDto.borrowerIds,
      ExistingExemptionNumber: exemptionDto.exemptionNumber,
    }),
  );
};



// WEBPACK FOOTER //
// ./src/utils/requests.js